// Utils
import { PHONE_REGEX, looseEmail } from '@shopee/validators';
import {
  localMobilePhoneValidator,
  formatPhoneNumberForServer,
} from '@shopee-user/authentication-utils';

export function phoneOrEmailValidator({
  isEmailAllowed,
  isPhoneAllowed,
  phoneErrorMessage,
  emailErrorMessage,
  requiredErrorMessage,
}: {
  isEmailAllowed: boolean;
  isPhoneAllowed: boolean;
  phoneErrorMessage: string;
  emailErrorMessage: string;
  requiredErrorMessage: string;
}) {
  return (
    value: string
  ): string | null | undefined | Promise<string | null | undefined> => {
    if (!value) {
      return requiredErrorMessage;
    }
    // As long as email is not allowed, we will use the phone validator directly.
    // Dev should ensure at least one of phone or email is allowed.
    if (!isEmailAllowed || (isPhoneAllowed && PHONE_REGEX.test(value))) {
      return localMobilePhoneValidator(phoneErrorMessage)(value);
    } else {
      return looseEmail(emailErrorMessage)(value);
    }
  };
}

export function checkPhoneReuseValidator({
  phoneToCompare,
  errorMessage,
}: {
  phoneToCompare: string;
  errorMessage: string;
}) {
  return async (value: string) => {
    const formattedValueToCompare = await formatPhoneNumberForServer(
      phoneToCompare
    );
    const formattedNewValue = await formatPhoneNumberForServer(value);
    if (formattedValueToCompare === formattedNewValue) {
      return errorMessage;
    }

    return null;
  };
}

export function checkEmailReuseValidator({
  emailToCompare,
  errorMessage,
}: {
  emailToCompare: string;
  errorMessage: string;
}) {
  return (value: string) => {
    if (emailToCompare === value) {
      return errorMessage;
    }
    return null;
  };
}
